<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.partner-alimony.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="partnerAlimonyAmount"
    [helpText]="'financial-obligations.partner-alimony.help-text' | apContent"
    [label]="'global.monthly-input.label' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.partner-alimony.amount.additional-info.title"
    contentKey="financial-obligations.partner-alimony.amount.additional-info.content"
    modalUrlKey="financial-obligations.partner-alimony.amount.additional-info.title"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
